import "./scss/legacy.scss";

import "../common/social.js";
import { each } from "../common/polyfill.js";

import L from "leaflet";
import "leaflet/dist/leaflet.css";

import Vue from "vue";
import VueChartist from "vue-chartist";
import VueRouter from "vue-router";

import ChartEmbed from "./components/ChartEmbed.vue";
import Victim from "./components/Victim.vue";
import VictimsChart from "./components/VictimsChart.vue";
import VictimsHome from "./components/VictimsHome.vue";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

each(".vue-victim", el => {
  new Vue({
    render: h => h(Victim),
    el: el
  });
});

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/",
      component: VictimsHome,
      props: route => ({
        range: route.query.range,
        district: route.query.district,
        // Fix for 'All' being used inconsistently in PHP site:
        zipcode: route.query.zipcode
          ? route.query.zipcode.toLowerCase()
          : undefined,
        cause: route.query.cause,
        age: route.query.age,
        gender: route.query.gender,
        race: route.query.race
      })
    }
  ]
});

each(".vue-victims-home", el => {
  new Vue({
    render: h => h(Vue.component("router-view")),
    router,
    el
  });
});

Vue.use(VueChartist);

each(".vue-yearly-charts", el => {
  new Vue({
    render: h => h(VictimsChart),
    el: el
  });
});

each(".vue-chart-embed", el => {
  new Vue({
    render: h => h(ChartEmbed),
    el: el
  });
});
